import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from "react-redux";
import cx from 'classnames';
import styles from './css/BloccoDocenze.module.css';
import * as _ from 'lodash';
import InputElement from "./InputElement";
import {listaIndividui, listaUnitaFormative} from "../../fanctionUtility";

const BloccoDocenze = ({
                           idAnagraficaDocente,
                           changeValueBlockTraining,
                           coDocenti,
                           idUnitaFormativa,
                           disabled
                       }) => {
    const docentiCorso = useSelector(state => state.corso.corso.docenti);
    const docenti = useSelector(state => state.docenti.docenti)

    const openMenu = () => {
        const element = document.getElementById('container__docenti');
        if (element) {
            element.classList.toggle('show');
            element.addEventListener('mouseleave', closeMenu)
        }
    };

    const closeMenu = () => {
        document.getElementById('container__docenti').classList.remove('show');
    };

    const selectItem = ({target}, idAnagraficaDocente) => {
        const updatedValue = [...coDocenti.value]; // Create a copy of the array
        if (updatedValue.includes(idAnagraficaDocente)) {
            updatedValue.splice(updatedValue.indexOf(idAnagraficaDocente), 1);
            target.parentNode.removeChild(target.parentNode.childNodes[1]);
        } else {
            updatedValue.push(idAnagraficaDocente);
            const el = document.createElement('i');
            el.classList.add('fa', 'fa-check', 'text-success', 'float-right');
            target.appendChild(el);
        }
        changeValueBlockTraining({coDocenti: {...coDocenti, value: updatedValue}});
    };

const removeItem = ({target}, idAnagraficaDocente) => {
    const updatedValue = coDocenti.value.filter(item => item !== idAnagraficaDocente);
    changeValueBlockTraining({coDocenti: {...coDocenti, value: updatedValue}});
};

    const changeValue = ({target}) => {
        idAnagraficaDocente.value = target.value;
        idAnagraficaDocente.validation.required = target.value !== '';
        idAnagraficaDocente.elementConfig.options = idAnagraficaDocente.validation.required ?
            (idAnagraficaDocente.elementConfig.options.length === 0 &&
                _.findIndex(idAnagraficaDocente.elementConfig.options, (obj) => obj.value === '') === -1) ?
                [{value: '', displayValue: ''}, ...idAnagraficaDocente.elementConfig.options] :
                idAnagraficaDocente.elementConfig.options :
            listaIndividui(docenti);

        coDocenti.validation.required = target.value !== '';
        coDocenti.value = [];

        // retrieve unita formative connected to professor
        const unitaFormative = docentiCorso.filter(dc => dc.idAnagrafica === target.value).map(dc => dc.unitaFormative).flat();

        idUnitaFormativa.validation.required = unitaFormative != null && unitaFormative.length > 0;
        idUnitaFormativa.elementConfig.disabled = unitaFormative == null || unitaFormative.length === 0;

        idUnitaFormativa.value = (unitaFormative != null && unitaFormative.length > 0) ? listaUnitaFormative(unitaFormative)[0].value : '';
        idUnitaFormativa.elementConfig.options = unitaFormative != null ? listaUnitaFormative(unitaFormative) : [];
        idUnitaFormativa.valid = idUnitaFormativa.touched = idUnitaFormativa.value !== '' || !idUnitaFormativa.validation.required;

        if (idUnitaFormativa.value !== '') {
            const unitaFormativa = unitaFormative.find(x => x.id === idUnitaFormativa.value);
            idUnitaFormativa.limiteOre = unitaFormativa.limiteOre != null ? unitaFormativa.limiteOre : 0;
        } else {
            idUnitaFormativa.limiteOre = 0;
        }

        changeValueBlockTraining({idUnitaFormativa, idAnagraficaDocente, coDocenti});
    };

    const updateLimiteOre = (idUnitaFormativa) => {
        const unitaFormative = docentiCorso.filter(dc => dc.idAnagrafica === idAnagraficaDocente.value).map(dc => dc.unitaFormative);
        const lm = unitaFormative.flat().find(x => x.id === idUnitaFormativa).limiteOre;
        return lm ? lm : 0;
    };

    return (
        <section className='mt-2 py-2'>
            <div className='row'>
                <InputElement label={idAnagraficaDocente.label}
                              elementType={idAnagraficaDocente.elementType}
                              elementConfig={idAnagraficaDocente.elementConfig}
                              value={idAnagraficaDocente.value}
                              invalid={!idAnagraficaDocente.valid}
                              touched={idAnagraficaDocente.touched}
                              changedValue={(event) => changeValue(event, 'idAnagraficaDocente')}
                              isRequired={idAnagraficaDocente.validation.required}
                              classes={idAnagraficaDocente.cssClass}
                              feedback={idAnagraficaDocente.error}
                />

                <InputElement label={idUnitaFormativa.label}
                              elementType={idUnitaFormativa.elementType}
                              elementConfig={idUnitaFormativa.elementConfig}
                              value={idUnitaFormativa.value}
                              invalid={!idUnitaFormativa.valid}
                              touched={idUnitaFormativa.touched}
                              changedValue={(event) => {
                                  idUnitaFormativa.value = event.target.value;
                                  idUnitaFormativa.limiteOre = updateLimiteOre(event.target.value);
                                  idUnitaFormativa.valid = idUnitaFormativa.touched = idUnitaFormativa.value !== '' || !idUnitaFormativa.validation.required;
                                  changeValueBlockTraining({idUnitaFormativa})
                              }}
                              isRequired={idUnitaFormativa.validation.required}
                              classes={idUnitaFormativa.cssClass}
                              feedback={idUnitaFormativa.error}
                />

                {idUnitaFormativa.value !== '' && (
                    <div
                        className='col-2 d-flex flex-wrap align-items-end justify-content-around'>
                        <label style={{borderBottom: '1px solid black', fontSize: '20px'}}>
                            Ore limite:
                        </label>
                        <div style={{marginBottom: '8px', fontSize: '20px', fontWeight: 800}}>
                            {idUnitaFormativa.limiteOre}
                        </div>
                    </div>
                )}
            </div>

            <div className='mt-2'>
                <div className='row justify-content-between'>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                        <label htmlFor='cooDocenza'>Codocenza </label>
                        {!disabled && (
                            <React.Fragment>
                                <div className='form-control dropdown-toggle' onClick={() => openMenu()}
                                     style={{cursor: 'pointer'}}>
                                    <span className='text-muted'>
                                        {idAnagraficaDocente.value === '' ? '-- Selezionare prima il docente --' : '-- Possibili coodocenti --'}
                                    </span>
                                </div>
                                {idAnagraficaDocente.value !== '' &&
                                    <div className='dropdown__container' id='container__docenti'>
                                        {listaIndividui(docenti.filter(d => d.idAnagrafica !== idAnagraficaDocente.value)).map(d =>
                                            (
                                                <div key={Math.random().toString(33).replace('0.', '')}
                                                     className='dropdown__container-element'>
                                                    <p onClick={(e) => selectItem(e, d.value)}
                                                       style={{cursor: 'pointer', marginBottom: 0}}>
                                                        {d.displayValue}
                                                    </p>
                                                    {coDocenti.value.includes(d.value) ?
                                                        <i className='fa fa-check text-success float-right'
                                                           style={{paddingTop: '5px'}}/> : null}
                                                </div>
                                            )
                                        )}
                                    </div>
                                }
                            </React.Fragment>)}
                    </div>


                    <div
                        className={disabled ? 'col-12' : 'col-md-6 col-12 col-sm-12 col-lg-6'}>
                        <div style={{ marginTop: !disabled ? '30px' : 0, backgroundColor: disabled && '#e9ecef'}}
                             className={cx('form-control p  -3 d-inline-flex flex-row flex-wrap align-items-start', styles.containerList )}>

                            {_.chunk(coDocenti.value, 2)
                                .map((chunk, index) =>
                                    <ul style={{listStyle: "none"}} key={index}>
                                        {chunk.map(idAnagraficaDocente => {
                                                const index = docenti.map(d => d.idAnagrafica).indexOf(idAnagraficaDocente);
                                                return (
                                                    <li key={idAnagraficaDocente}
                                                        className='text-capitalize'>
                                                        {!disabled &&
                                                            <button className="btn btn-sm btn-danger shadow mr-2" type="button"
                                                                    onClick={(e) => removeItem(e, idAnagraficaDocente)}>
                                                                <i className="fa fa-lg fa-times"></i>
                                                            </button>
                                                        }

                                                        <span>
                                                            {`${docenti[index].cognome.toLowerCase()} ${docenti[index].nome.toLowerCase()}`}
                                                        </span>

                                                    </li>
                                                )
                                            }
                                        )}
                                    </ul>
                                )
                            }

                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
};

BloccoDocenze.propTypes = {
    idAnagraficaDocente: PropTypes.shape({
        elementType: PropTypes.string,
        elementConfig: PropTypes.shape({
            type: PropTypes.string
        }),
        value: PropTypes.string,
        label: PropTypes.string,
        valid: PropTypes.bool.isRequired,
        touched: PropTypes.bool.isRequired,
        cssClass: PropTypes.string,
        validation: PropTypes.shape({
            required: PropTypes.bool.isRequired
        }),
        error: PropTypes.string
    }).isRequired,
    coDocenti: PropTypes.shape({
        elementType: PropTypes.string,
        elementConfig: PropTypes.shape({
            type: PropTypes.string
        }),
        value: PropTypes.arrayOf(PropTypes.string),
        label: PropTypes.string,
        valid: PropTypes.bool.isRequired,
        touched: PropTypes.bool.isRequired,
        cssClass: PropTypes.string,
        validation: PropTypes.shape({
            required: PropTypes.bool.isRequired
        }),
        error: PropTypes.string
    }).isRequired,
    idUnitaFormativa: PropTypes.shape({
        elementType: PropTypes.string,
        elementConfig: PropTypes.shape({
            type: PropTypes.string
        }),
        value: PropTypes.string,
        label: PropTypes.string,
        valid: PropTypes.bool.isRequired,
        touched: PropTypes.bool.isRequired,
        cssClass: PropTypes.string,
        validation: PropTypes.shape({
            required: PropTypes.bool.isRequired
        }),
        error: PropTypes.string
    }).isRequired,
    disabled: PropTypes.bool,
    changeValueBlockTraining: PropTypes.func

};

BloccoDocenze.defaultProps = {
    idAnagraficaDocente: {
        elementType: 'select',
        elementConfig: {
            options: []
        },
        value: '',
        label: 'Resp. Progetto/Docente',
        valid: true,
        touched: true,
        cssClass: 'col-md-6 col-12 col-sm-12 col-lg-6',
        validation: {
            required: false
        },
        error: 'Id docente non presente nella pianificazione'
    },
    coDocenti: {
        elementType: 'select',
        elementConfig: {
            options: []
        },
        value: [],
        label: 'Codocenti',
        valid: true,
        touched: true,
        cssClass: 'col-md-6 col-12 col-sm-12 col-lg-6',
        validation: {
            required: false
        },
        error: ''
    },
    idUnitaFormativa: {
        elementType: 'select',
        elementConfig: {
            options: []
        },
        value: '',
        label: 'Unita formativa',
        valid: true,
        touched: true,
        cssClass: 'col-md-6 col-12 col-sm-12 col-lg-6 mt-2',
        validation: {
            required: false
        },
        error: 'Selezionare Unità formativa'
    }
};

export default BloccoDocenze;

